var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,40v-5.6c0-1.1,0.3-2.2,0.8-3.1c0.5-0.9,1.4-1.7,2.3-2.2c1.9-0.9,3.8-1.7,5.8-2.2c2.3-0.6,4.6-0.9,7-0.9c1,0,1.9,0,2.9,0.1c0.9,0.1,1.9,0.2,2.8,0.5l-3.5,3.5C21.8,30,21.5,30,21.1,30H20c-2.2,0-4.3,0.3-6.4,0.9c-1.6,0.5-3.2,1.1-4.6,1.9c-0.3,0.2-0.5,0.4-0.7,0.7C8.1,33.7,8,34,8,34.4V36h12.5l4,4H4z M31.1,40.8l-6.9-6.9l2.8-2.8l4.1,4.1l10.1-10.1l2.8,2.8L31.1,40.8z M20,24c-2.1,0-4.2-0.8-5.6-2.4C12.8,20.2,12,18.1,12,16c0-2.1,0.8-4.2,2.4-5.6C15.8,8.8,17.9,8,20,8c2.1,0,4.2,0.8,5.6,2.4c1.5,1.5,2.4,3.5,2.4,5.6c0,2.1-0.8,4.2-2.4,5.6C24.2,23.2,22.1,24,20,24z M20,20c2.2,0,4-1.8,4-4s-1.8-4-4-4s-4,1.8-4,4S17.8,20,20,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvice);
export default __webpack_public_path__ + "static/media/advice.f821c5021fbddf4ee2662f1c9d7368a7.svg";
export { ForwardRef as ReactComponent };